/* Édition theme — core interactions (no framework, no build step). */
(function () {
  "use strict";

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Drawer helper ---------------- */
  function Drawer(el) {
    if (!el) return null;
    return {
      el: el,
      open: function () {
        el.setAttribute("data-open", "true");
        document.documentElement.style.overflow = "hidden";
        var overlay = qs('[data-overlay-for="' + el.id + '"]') || qs(".overlay");
        if (overlay) overlay.setAttribute("data-open", "true");
      },
      close: function () {
        el.setAttribute("data-open", "false");
        document.documentElement.style.overflow = "";
        qsa(".overlay").forEach(function (o) { o.setAttribute("data-open", "false"); });
      }
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    var mobileNav = Drawer(qs("#mobile-nav"));
    var searchDrawer = Drawer(qs("#search-drawer"));
    var filterDrawer = Drawer(qs("#filter-drawer"));
    var cartDrawer = Drawer(qs("#cart-drawer"));

    qsa("[data-open-mobile-nav]").forEach(function (b) { b.addEventListener("click", function () { mobileNav && mobileNav.open(); }); });
    qsa("[data-close-mobile-nav]").forEach(function (b) { b.addEventListener("click", function () { mobileNav && mobileNav.close(); }); });

    qsa("[data-open-search]").forEach(function (b) { b.addEventListener("click", function () { searchDrawer && searchDrawer.open(); qs("#search-drawer input") && qs("#search-drawer input").focus(); }); });
    qsa("[data-close-search]").forEach(function (b) { b.addEventListener("click", function () { searchDrawer && searchDrawer.close(); }); });

    qsa("[data-open-filters]").forEach(function (b) { b.addEventListener("click", function () { filterDrawer && filterDrawer.open(); }); });
    qsa("[data-close-filters]").forEach(function (b) { b.addEventListener("click", function () { filterDrawer && filterDrawer.close(); }); });

    qsa("[data-open-cart]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        cartDrawer && cartDrawer.open();
      });
    });
    qsa("[data-close-cart]").forEach(function (b) { b.addEventListener("click", function () { cartDrawer && cartDrawer.close(); }); });

    qsa(".overlay").forEach(function (o) {
      o.addEventListener("click", function () {
        [mobileNav, searchDrawer, filterDrawer, cartDrawer].forEach(function (d) { d && d.close(); });
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        [mobileNav, searchDrawer, filterDrawer, cartDrawer].forEach(function (d) { d && d.close(); });
      }
    });

    /* Sort select: navigate with sort_by param, preserving filters */
    var sortSelect = qs("[data-sort-select]");
    if (sortSelect) {
      sortSelect.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortSelect.value);
        window.location.href = url.toString();
      });
    }

    /* Quantity steppers (product page + cart) */
    qsa("[data-qty-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var wrap = btn.closest(".qty-input");
        var input = qs("input", wrap);
        var step = parseInt(btn.getAttribute("data-qty-step"), 10);
        var min = parseInt(input.getAttribute("min") || "1", 10);
        var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    /* Cart line quantity change -> update via Ajax API */
    qsa("[data-cart-qty-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        updateCartLine(input.getAttribute("data-line-key"), input.value);
      });
    });
    qsa("[data-cart-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        updateCartLine(btn.getAttribute("data-line-key"), 0);
      });
    });

    /* Product form variant swatches */
    qsa("[data-variant-picker]").forEach(initVariantPicker);

    /* Product form submit via Ajax (Add to cart -> open drawer) */
    qsa("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = qs('[type="submit"]', form);
        if (submitBtn) submitBtn.setAttribute("disabled", "true");
        fetch("/cart/add.js", { method: "POST", body: formData, headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function () {
            return refreshCartDrawer();
          })
          .then(function () {
            if (submitBtn) submitBtn.removeAttribute("disabled");
            cartDrawer && cartDrawer.open();
          })
          .catch(function () {
            if (submitBtn) submitBtn.removeAttribute("disabled");
            form.submit();
          });
      });
    });
  });

  function updateCartLine(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { window.location.reload(); });
  }

  function refreshCartDrawer() {
    return fetch("/?section_id=cart-drawer")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("#cart-drawer");
        var current = document.querySelector("#cart-drawer");
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
        }
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        qsa("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "" : "none";
        });
      });
  }

  function initVariantPicker(wrapper) {
    var productJsonEl = qs('[data-product-json]', wrapper.closest("[data-product-form]"));
    if (!productJsonEl) return;
    var product = JSON.parse(productJsonEl.textContent);
    var form = wrapper.closest("[data-product-form]");
    var idInput = qs('input[name="id"]', form);
    var priceEl = qs("[data-product-price]", form);
    var addBtn = qs('[data-add-to-cart]', form);

    function selectedOptions() {
      return qsa(".swatch-list", wrapper).map(function (list) {
        var active = qs('.swatch[data-selected="true"]', list);
        return active ? active.getAttribute("data-value") : null;
      });
    }

    function findVariant() {
      var opts = selectedOptions();
      return product.variants.find(function (v) {
        return [v.option1, v.option2, v.option3].every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute("disabled");
          addBtn.textContent = addBtn.getAttribute("data-label-add") || "Ajouter au panier";
        } else {
          addBtn.setAttribute("disabled", "true");
          addBtn.textContent = addBtn.getAttribute("data-label-soldout") || "Épuisé";
        }
      }
    }

    qsa(".swatch", wrapper).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.hasAttribute("disabled")) return;
        qsa(".swatch", btn.closest(".swatch-list")).forEach(function (b) { b.setAttribute("data-selected", "false"); });
        btn.setAttribute("data-selected", "true");
        render();
      });
    });

    render();
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2 }) + " \u20AC";
  }
})();
